

import '../pages/Gachapon.scss';
import { useLottie } from "lottie-react";
import { useEffect, useState } from "react";
import { GachaResult, Rabbit } from "../api/types";

import gachaponResult from "./gachapon_result.json";
import gachaponPayreveal from "./gachapon_payreveal.json";
import gachaponLevelUp from "./gachapon_levelup.json";

import useSound from 'use-sound';


const GachaponBall = ({showPrize, showResult,p2sEnabled}: {showPrize:() => void, showResult:GachaResult | undefined, p2sEnabled:boolean}) => {
    const [revealSound, revealSoundData] = useSound('/audio/reveal.mp3');
    const options = {
      animationData: p2sEnabled ? gachaponPayreveal : gachaponResult,
      loop: false,
      autoplay: false,
      onComplete: () => {
        
      }
    };
  
    const { View, play } = useLottie(options);

    useEffect(() => {
        if(showResult){
            play()
            setTimeout(() => {
                showPrize()
                
            }, 2500)
        }    
    }, [showResult, play])

    return <div className="Gachapon--Result--Ball">
        {View}
    </div>;
  };

  const GachaponLevelUp = () => {
        
    const options = {
      animationData: gachaponLevelUp,
      loop: true,
      autoplay: true,
      onComplete: () => {
        
      }
    };
  
    const { View, play } = useLottie(options);

   

    return (

        <div>{View}</div>
    )
  };


  const GachaponResult = ({showPrize, hideResult, isLevelUp, nextSpin, p2sEnabled} : {showPrize: GachaResult | undefined, hideResult: () => void, isLevelUp:boolean, nextSpin: any, p2sEnabled:boolean}) => {
    let [reveal, setReveal] = useState<Boolean>(false)
    let [lvlUp, setLvlUp] = useState<Boolean>(false)
    let [prizeDetails, setPrizeDetails] = useState<any | null>(null)
    
    const [clickSound, clickSoundData] = useSound('/audio/click.mp3', { volume: 0.03 });
    const [levelupSound, levelupSoundData] = useSound('/audio/levelup.mp3', { volume: 0.05 });

    const tokenTypes = ["wl_spot", "digital_good", "FRRT"]

    useEffect(() => {
        if(!showPrize){
            setReveal(false)
        } else {
            setPrizeDetails(showPrize)
            
        }
    }, [showPrize, reveal])

      return (
        <div className={`Gachapon--Result ${(showPrize) ? "show" : ""} ${(lvlUp) ? "lvlup" : ""}`}>
            <button className='Gachapon--Result--Close' onClick={() => { clickSound(); if(lvlUp || isLevelUp === false) { setReveal(false); setLvlUp(false); hideResult(); } else { setLvlUp(true); levelupSound(); setTimeout(() => { setReveal(false); setLvlUp(false); hideResult(); }, 2500)  } }}>x</button>
            <div className='lvlUpWrapper'>
                {lvlUp && <GachaponLevelUp/>}

            </div>

            <div className={`Gachapon--Result--Prize ${(reveal === true) ? "revealed" : ""}`}>
                    <img src={(prizeDetails) ? prizeDetails.image : ""} alt="" />
                    
                    <div className="Gachapon--Result--Content">
                        <div className="Gachapon--Result--Title">Congratulations!!!</div>
                        
                        <div className="Gachapon--Result--Text">You've just won <span>{(prizeDetails) ? prizeDetails.name : ""}</span>.</div>
                        {prizeDetails && (tokenTypes.includes(prizeDetails.type) || (prizeDetails.splToken && tokenTypes.includes(prizeDetails.splToken)) ) && <div className="Gachapon--Result--Text">This prize can be claimed in the <a href={`https://hub.flippinrabbits.xyz`} target={`_blank`}>Flippin' Hub</a>.</div>}
                        {p2sEnabled === false && <><div className="Gachapon--Result--Text">Your next spin will be unlocked at</div>
                        <div className="Gachapon--Result--Time">{nextSpin.long}</div></>}
                        {prizeDetails && prizeDetails.type.indexOf("exp_") == -1 ? <a className="Gachapon--Result--Share" href={`https://twitter.com/intent/tweet?url=https://flippinrabbits.xyz&hashtags=JustFlipIt,WAGFI&text=I've just won ${prizeDetails.name} on Flippin' Gach. That's FLIPPIN' AWESOME! Know more at @FlippinRabbits`} target="_blank">Share my spin</a> : null }
                    </div>
                </div>
            {(showPrize) ? <GachaponBall p2sEnabled={p2sEnabled} showResult={(showPrize)} showPrize={() => { setReveal(true) }} /> : null}
        </div>
      )

  }

  export default GachaponResult;